<script setup lang="ts">
import type { ProductLabel } from '~/types/misc'

defineProps<{
  label: ProductLabel
}>()
</script>

<template>
  <span :style="label.style">
    {{ label.label }}
  </span>
</template>
